import useSubGroup from "../hook/useSubGroup";

export const SubGroupSelect = () => {
    const { allSubGroups, selectedSubGroupId, setSelectedSubGroupId }: any = useSubGroup();

    return (
        <select
            className="border-2 border-secondary px-2 py-2 xm:py-1 outline-none w-full xm:w-auto"
            value={selectedSubGroupId}
            onChange={(e) => setSelectedSubGroupId(parseInt(e.target.value))}
        >
            <option value={0}>All</option>
            {
                allSubGroups?.map((item: any, index: number) => (
                    <option
                        key={index}
                        value={item?.value}
                    >
                        {item?.label}
                    </option>
                ))
            }
        </select>
    )
}
